<div *ngIf="agent" class="tr layout-row layout-align-start-center table-row"
     [ngClass]="{'odd': index % 2 === 0}">

  <!--Fixed Columns-->
  <div class="layout-row layout-align-center-center td sticky fixed-columns">
    <div ngbDropdown container="body">
      <button class="action-menu"
              (click)="$event.stopPropagation();"
              ngbDropdownToggle>
        <bringoz-icon iconName="menu"></bringoz-icon>
      </button>
      <div ngbDropdownMenu aria-labelledby="agent-action-menu">
        <button ngbDropdownItem (click)="onDisableAllDays()">
          <span class="br-body-2" translate>Disable all project days</span>
        </button>
      </div>
    </div>
    <div class="fixed-col-employee layout-column layout-align-center-start">
      <span class="br-body-2 gray-101">{{ agent.agentReference | userName }}</span>
      <branches-indicator [branches]="agent.branchReferences"
                          [openInNewTab]="true"></branches-indicator>
      <div class="layout-row layout-align-start-center gap-5">
        <div *ngIf="agent.isExternal" class="imported-container">
          <span class="br-caption-1" translate>Imported</span>
        </div>
        <app-bringoz-tags class="margin-top-5"
                          [tags]="agent.agentReference.tags"
                          [maxTags]="1">
        </app-bringoz-tags>
      </div>
    </div>
  </div>

  <!--Date Columns-->
  <div *ngFor="let date of dates"
       class="td flex layout-column day-col "
       [ngClass]="{
         'has-availability': dateInfo.get(date)?.hasAvailability,
         'has-leave': dateInfo.get(date)?.hasLeave,
         'has-conflict': dateInfo.get(date)?.hasConflict,
         'unavailable-cell': dateInfo.get(date)?.availabilityData.notAvailable || (!dateInfo.get(date)?.availabilityData.available && dateInfo.get(date)?.availabilityData.timeWindow)
       }">

    <app-availability-table-cell class="flex"
      [availability]="dateInfo.get(date)?.availabilityData"
      [visitPlan]="visitPlan"
      [visitScheduleId]="visitScheduleId"
      [resources]="dateInfo.get(date)?.resources"
      [conflictingResourceIds]="conflictingResourceIds"
      [agent]="agent"
      [date]="date"
      [zoneId]="zoneId"
      (resourcesUpdated)="onResourcesUpdated($event)">
    </app-availability-table-cell>
  </div>
</div>

